module.exports = __webpack_public_path__ + "static/media/resultbanner.45cc5d72.svg";